import { openShareScene, closeShareScene } from '@bilibili/fe-quick-share'
import { SharePanelConfig } from '../model/common'
/**
 * 唤起分享面板
 * @param {*} shareConfig
 * @param {*} shareImageUrl
 * @param {*} triggerClick // 是否在 click icon 的时候触发回调。默认为false
 */
export function openSharePanel({
  title,
  description,
  avatar,
  editContent,
  shareConfig,
  shareImageUrl,
  callback,
  triggerClick = false,
  type = 'link',
  url = location.href,
  share_id,
  share_origin,
}: SharePanelConfig) {
  console.log('11111')
  openShareScene({
    business: 'OGV',
    pageId: 'cross-year-mobile-2021',
    shareScene: 'cross-year',
    shareUrls: [url],
    defineBar: true,
    share2Config: {
      share_id,
      share_origin,
      oid: url, // 分享对象id, 配合share_id使用, 对于h5, 传递的是url
      sid: '', // 辅助id, 当oid无法定位的时候, 使用oid+sid来关联
    },
    shareInfo: {
      DEFAULT: {
        type,
        title,
        avatar,
        url: url,
        desc: description,
        imageUrl: shareImageUrl,
      },
      BILI_DYNAMIC: {
        description, // read 图片时无作用
        editContent,
        pictureList: [
          {
            width: 750,
            height: shareConfig.height,
            size: 2000,
            src: shareImageUrl,
          },
        ],
      },
    },
    onSuccess: () => {
      if (!triggerClick) {
        closeShareScene && closeShareScene()
        callback && callback()
      }
    },
    // onClick: (info: ShareItem) => {
    //   const { channel } = info
    //   // 微博点击即成功
    //   if (channel === 'SINA_WEIBO' || triggerClick) {
    //     // 点击即成功
    //     closeShareScene && closeShareScene()
    //     callback && callback()
    //   }
    // },
  })
}
